import { useState } from "react";
import { supabase } from "../supabase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) setError(error.message);
    setLoading(false);
  };

  const inputStyle = {
    width: "100%",
    border: "0.5px solid #e0e0e0",
    borderRadius: "8px",
    padding: "8px 12px",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box",
    color: "#111",
    fontFamily: "inherit",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8f8f8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          border: "0.5px solid #e8e8e8",
          padding: "32px",
          width: "100%",
          maxWidth: "360px",
        }}
      >
        {/* Logo + brand */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "28px",
          }}
        >
          <img
            src="/Icon.png"
            alt="Porso"
            style={{
              height: "56px",
              width: "56px",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
          <div>
            <div className="t-name" style={{ fontSize: "14px" }}>
              Porso Freight
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "#3a9e5f",
                fontWeight: "500",
                letterSpacing: "0.01em",
              }}
            >
              Driver Management
            </div>
          </div>
        </div>

        {/* Heading */}
        <div style={{ marginBottom: "20px" }}>
          <div
            style={{
              fontSize: "18px",
              fontWeight: "600",
              letterSpacing: "-0.02em",
              color: "#111",
              marginBottom: "3px",
            }}
          >
            Sign in
          </div>
          <div className="t-label" style={{ color: "#9ca3af" }}>
            Sign in to your team account
          </div>
        </div>

        {/* Error */}
        {error && (
          <div
            style={{
              background: "#fcebeb",
              borderRadius: "8px",
              padding: "10px 14px",
              marginBottom: "16px",
            }}
          >
            <span className="t-body" style={{ color: "#a32d2d" }}>
              {error}
            </span>
          </div>
        )}

        {/* Form */}
        <form
          onSubmit={handleLogin}
          style={{ display: "flex", flexDirection: "column", gap: "14px" }}
        >
          <div>
            <div className="t-label" style={{ marginBottom: "5px" }}>
              Email
            </div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@porsofreight.com"
              required
              style={inputStyle}
            />
          </div>
          <div>
            <div className="t-label" style={{ marginBottom: "5px" }}>
              Password
            </div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={inputStyle}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              background: "#3a9e5f",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "500",
              letterSpacing: "-0.01em",
              padding: "9px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              opacity: loading ? 0.7 : 1,
              transition: "opacity 0.15s",
              marginTop: "4px",
            }}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
